import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Order, OrderItem } from '@us/web/shared/data-access';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Injectable({
    providedIn: 'root'
})
export class TrackerService {
    private readonly googleAnalyticsService = inject(GoogleAnalyticsService);
    private readonly store = inject(Store);

    public addToCart(item: OrderItem) {
        this.googleAnalyticsService.gtag('event', 'add_to_cart', {
            currency: 'VND',
            value: item.price * item.quantity,
            items: [
                {
                    item_id: item.product_name,
                    item_name: item.product_name,
                    discount: item.discount?.price,
                    item_category: item.category_name,
                    price: item.price,
                    quantity: item.quantity
                }
            ]
        });
    }

    public beginCheckout(cart: Order) {
        this.googleAnalyticsService.gtag('event', 'begin_checkout', {
            currency: 'VND',
            value: cart.grand_total,
            items: cart.items.map(item => ({
                item_id: item.product_name,
                item_name: item.product_name,
                discount: item.discount?.price,
                item_category: item.category_name,
                price: item.price,
                quantity: item.quantity
            }))
        });
    }

    public purchase(order: Order) {
        this.googleAnalyticsService.gtag('event', 'purchase', {
            transaction_id: order.order_id,
            value: order.grand_total,
            tax: 0, // TODO
            shipping: order.delivery?.delivery_fee || 0,
            currency: 'VND',
            // coupon: 'SUMMER_SALE',
            items: order.items.map(item => ({
                item_id: item.product_name,
                item_name: item.product_name,
                discount: item.discount?.price,
                item_category: item.category_name,
                price: item.price,
                quantity: item.quantity
            }))
        });
    }
}
